define('even',['backbone'], function (Backbone) {

	return _.extend({}, Backbone.Events);

});
